import { FC } from "react";
import {
  LocationActionAnnualStatusEnum,
  LocationActionOnDemandStatusEnum,
} from "service";
import { Box } from "@mui/material";
import { useAppTheme } from "../dark-theme";
import { NotificationsStatusEnum } from "service/types/enum/notifications-enum";

export interface StatusDotProps {
  status:
    | LocationActionAnnualStatusEnum
    | LocationActionOnDemandStatusEnum
    | NotificationsStatusEnum;
  size?: number;
}
export const StatusDot: FC<StatusDotProps> = (props) => {
  const { status, size = 8 } = props;
  const {
    palette: { success, warning, error, info },
  } = useAppTheme();

  const getDotColor = () => {
    if (
      status === LocationActionAnnualStatusEnum.home ||
      status === LocationActionOnDemandStatusEnum.earlyPlow ||
      status === NotificationsStatusEnum.sent
    ) {
      return success.main;
    }

    if (
      status === LocationActionAnnualStatusEnum.delayed ||
      status === LocationActionOnDemandStatusEnum.latePlow ||
      status === NotificationsStatusEnum.draft
    ) {
      return warning.main;
    }

    if (
      status === LocationActionAnnualStatusEnum.away ||
      status === NotificationsStatusEnum.notSent
    ) {
      return error.main;
    }

    if (
      status === LocationActionAnnualStatusEnum.urgent ||
      status === LocationActionOnDemandStatusEnum.urgent
    ) {
      return info.main;
    }

    throw new Error("Invalid state in PillSelector getDotColor");
  };

  return (
    <Box
      sx={{
        backgroundColor: getDotColor(),
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${size * 2}px`,
      }}
    />
  );
};
